import { DELETE_B_LOADING, DELETE_B_SUCCESS, DELETE_B_FAILED } from "../types"

const initialState = {
  loading: false,
  error: false,
  deletedBooking: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE_B_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        deletedBooking: null,
      }
    case DELETE_B_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        deletedBooking: null,
      }
    case DELETE_B_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        deletedBooking: action.payload,
      }
    default:
      return state
  }
}
